import { Button, Icon, Modal } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const FullyInvestedError = ({ closeModal, isOpen }) => {
    const { t } = useTranslation();
    return (<Modal open={isOpen} size="md" className="!min-w-0 !max-w-[min(540px,calc(100vw-32px))]" onClose={closeModal} heading={t('financing.fully_invested.title')} footer={<Button onClick={closeModal} variant="primary" label={t('financing.fully_invested.button')}/>}>
            <div className="flex flex-col items-center gap-3 text-center">
                <div className="w-12 h-12 bg-surface-critical-secondary-initial rounded-full border border-critical-primary-initial flex justify-center items-center">
                    <Icon name="error_filled" className="text-critical-primary-initial"/>
                </div>
                <p className="body-m text-neutral-secondary-initial">{t('financing.fully_invested.message')}</p>
            </div>
        </Modal>);
};
export default FullyInvestedError;
